import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { Injectable } from "@angular/core";
import { NavController, AlertController } from 'ionic-angular';
import { ForgotPasswordStep1Component } from '../pages/auth/forgot-password/forgotPassword1.component';
import { ForgotPasswordStep2Component } from '../pages/auth/forgot-password/forgotPassword2.component';
import { ConfirmRegistrationComponent } from '../pages/auth/confirm-registration/confirmRegistration.component';
import { Users } from "../api/server/collections/users";
import { environment } from "../environments/environment";


const poolData = {
    UserPoolId : 'us-east-1_nGDO7QHjW',
    ClientId : '51rv37rilk02a50adi2c6oe94l'
};
const userPool = new CognitoUserPool(poolData);


export function MeteorUser(){
    const currentUser = userPool.getCurrentUser();
    return currentUser ? Users.findOne({"emails.address":currentUser['username']}) : null
}
export function CognitoLogout(){
    try {
        userPool.getCurrentUser().signOut()
        // @DAVIS navigate to login page
        // this.router.navigate(['/login']);
    } catch(err){
        console.log("cannot logout-- no user")
    }
}

@Injectable()

export class AuthenticationService {
    cognitoUser: CognitoUser;
    newPasswordUserAttributes: any;
    constructor(
        public alertCtrl: AlertController,
        // @DAVIS display message to user
        // import router and popup message at top
        // private router: Router
        ) {
    }
    async imageConverter(image: string){
        return `${environment.baseURL}/api/images?image=${image.split("https://logit-test-test.s3.amazonaws.com/")[1]}&authorization=${await this.getHeader()}`
    }
    deconvertImage(image: string){
        console.log("deconverting", image)
        try{
            console.log(`${environment.baseURL}/api/images?image=`, image.split(`${environment.baseURL}/api/images?image=`)[1])
            console.log(image.split(`${environment.baseURL}/api/images?image=`)[1].split(`&authorization=`)[0])
          return image.split(`${environment.baseURL}/api/images?image=`)[1].split(`&authorization=`)[0];
        } catch(err){}
    }

    // public async getHeader(): Promise<string>{
    public async getHeader(): Promise<any> {
        try {
            return new Promise(async (resolve, reject) => {
                try{
                    const currUser = await userPool.getCurrentUser();
                    if (currUser) {
                        currUser.getSession((err, res) => {
                            if (err) {
                                reject(err);
                            }
                            resolve(res.getAccessToken().getJwtToken());
                        });
                    } else {
                        console.log('user not logged in, rejecting getHeader promise...');
                        return null;
                    }
                }catch(err){
                    reject(err);
                }
            });
        } catch(err) {
            console.log('error getting header:', err);
            return null;
        }
    }

    public MeteorUser(): any{
        try {
            const currentUser = userPool.getCurrentUser();
            // console.log(currentUser['username'], Users.find({}).fetch(), Users.findOne())
            return currentUser ? Users.findOne({"emails.address":currentUser['username']}) : null
        } catch (err) {
            console.log('meteor user cognito error:', err)
        }
    }

    public MeteorUserId(): string | null{
        const meteorUser = this.MeteorUser()
        return meteorUser? meteorUser._id:meteorUser;
    }

    logout(){
        try {
            userPool.getCurrentUser().signOut()
            // @DAVIS navigate to login page
            // this.router.navigate(['/login']);
        } catch(err){
            console.log("cannot logout-- no user")
        }
    }
    async getCurrentUser() {
        let cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
            return new Promise((resolve, reject) => {
                cognitoUser.getSession((err, res)=> err ? reject(err):resolve(res))
            }).then(res=>{
                return new Promise((resolve, reject) => {
                    cognitoUser.getUserAttributes((err, res)=> err ? reject(err):resolve(res))
                })
            })
            .then(res=>{
                console.log("user is", res)
                return res;
            })
            .catch(err=>{
                console.log("errororororoor", err)
                this.logout();
                return false;
            })
        }
        else {
            this.logout();
            return false;
        }
    }
    registerUserPassword(password: string) {
        console.log("password, this.newPasswordUserAttributes", password, this.newPasswordUserAttributes)
        return new Promise((resolve, reject)=>{
            this.cognitoUser.completeNewPasswordChallenge(password, this.newPasswordUserAttributes, {
                onSuccess: (result) =>{
                    console.log("res", result)
                    this.getHeader()
                    // @DAVIS display message to user
                    //   this.toastr.success("Login succeeded", 'Password Updated')
                    // @DAVIS navigate to main page
                    //   this.router.navigate([''])
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err);
                    // @DAVIS display message to user
                    // this.toastr.error("Password reset failed", '')
                    // @DAVIS navigate to login page
                    // this.router.navigate(['/login']);
                }
            })
        })
    }
    initiateForgotPasswordFlow(email:string){
        const userData = {
            Username : email,
            Pool : userPool
          };
          this.cognitoUser = new CognitoUser(userData);
          this.cognitoUser.forgotPassword({
            onSuccess: (result) =>{
                console.log("res", result)
                // @DAVIS display message to user
                //   this.toastr.success("Password Reset Email Sent", 'Enter the code from your email')
              },
            onFailure: (err) => {
                // @DAVIS display message to user
                // this.toastr.error("Password reset failed", 'Check to make sure your user is registered')
            }
        })
    }
    resetPassword(email:string, code:string, password: string){
        const userData = {
            Username : email,
            Pool : userPool
          };
          this.cognitoUser = new CognitoUser(userData);
          this.cognitoUser.confirmPassword(code, password, {
            onSuccess: () =>{
                // @DAVIS display message to user
                //   this.toastr.success("Password Reset Successfully", 'You can now login with your new password')
                // @DAVIS navigate to login page
                //   this.router.navigate(['/login'])
              },
            onFailure: (err) => {
                // @DAVIS display message to user
                // this.toastr.error("Password reset failed", 'Check to make sure your user is registered')
            }

          })
    }
    login(email: string, password: string, cb?:any): Promise<String>{
        const userData = {
            Username : email,
            Pool : userPool
          };
          this.cognitoUser = new CognitoUser(userData);
          const authenticationData = {
            Username : email,
            Password : password,
        };
          const authenticationDetails = new AuthenticationDetails(authenticationData);
          if(cb){
            this.cognitoUser.authenticateUser(authenticationDetails, cb)
            return Promise.resolve("Custom Callback")
          }else{
            return new Promise((resolve, reject)=>{
                try{
                    this.cognitoUser.authenticateUser(authenticationDetails, {
                        onSuccess: (result) =>{
                            console.log("res", result)
                            console.log('LOGIN SUCCESS', result)
                            this.getHeader()
                            // @DAVIS display message to user
                            //   this.toastr.success("Login succeeded", 'Welcome!')
                            // @DAVIS navigate to main page
                            //   this.router.navigate([''])
                            resolve('success')
                        },
                        newPasswordRequired: (userAttributes, requiredAttributes) => {
                        // User was signed up by an admin and must provide new
                        // password and required attributes, if any, to complete
                        // authentication.
                        // the api doesn't accept this field back
                        delete userAttributes.email_verified;

                        // unsure about this field, but I don't send this back
                        delete userAttributes.phone_number_verified;
                        this.newPasswordUserAttributes=userAttributes;

                        resolve('newpasswordrequired')
                        //   nav.setRoot(RegisterComponent)
                        // @DAVIS navigate to set password for first time page
                        //   this.router.navigate(['/register'])
                    },

                        onFailure: (err) => {
                            console.error(err)
                            reject(err)
                            // @DAVIS display message to user
                            // this.toastr.error("Login failed", 'Check your email/password')
                        },

                        mfaRequired: (codeDeliveryDetails) => {
                            var verificationCode = prompt('Please input verification code' ,'');
                            // cognitoUser.sendMFACode(verificationCode, this);
                            // alert('mfa required')
                            resolve('mfarequired')
                        }

                    });
                } catch(err){
                    reject(err)
                }
            });
          }


    }
}



// WEBPACK FOOTER //
// ./src/services/congito.ts